import React from 'react'

const Courier = ({
  color = '#4E60FF',
  innerColor = '#F1F2FF',
}: {
  color?: string
  innerColor?: string
}) => {
  return (
    <svg
      width='98'
      height='82'
      viewBox='0 0 98 82'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.78 72.8899C14.73 77.0149 18.93 79.8699 23.8 79.8699C28.685 79.8699 32.895 76.9949 34.84 72.8449'
        fill={innerColor}
      />
      <path
        d='M83.405 79.8649C90.1346 79.8649 95.59 74.4095 95.59 67.6799C95.59 60.9503 90.1346 55.4949 83.405 55.4949C76.6754 55.4949 71.22 60.9503 71.22 67.6799C71.22 74.4095 76.6754 79.8649 83.405 79.8649Z'
        fill={innerColor}
      />
      <path d='M72.995 45.2249L63.405 17.7149H50.075' fill={innerColor} />
      <path
        d='M83.405 42.9299C71.52 42.9299 61.59 51.3099 59.2 62.4799H59.21H44.19C44.19 51.2149 35.06 42.0849 23.795 42.0849C12.53 42.0849 3.39996 51.2149 3.39996 62.4799H44.19'
        fill={innerColor}
      />
      <path d='M29.5 2.12988H2.83496V28.7949H29.5V2.12988Z' fill={innerColor} />
      <path
        d='M12.78 72.8899C14.73 77.0149 18.93 79.8699 23.8 79.8699C28.685 79.8699 32.895 76.9949 34.84 72.8449M72.995 45.2249L63.405 17.7149H50.075M80.61 28.5299V21.0599M83.405 42.9299C71.52 42.9299 61.59 51.3099 59.2 62.4799H59.21H44.19M44.19 62.4799C44.19 51.2149 35.06 42.0849 23.795 42.0849C12.53 42.0849 3.39996 51.2149 3.39996 62.4799H44.19ZM95.59 67.6799C95.59 74.4095 90.1346 79.8649 83.405 79.8649C76.6754 79.8649 71.22 74.4095 71.22 67.6799C71.22 60.9503 76.6754 55.4949 83.405 55.4949C90.1346 55.4949 95.59 60.9503 95.59 67.6799ZM2.83496 2.12988H29.5V28.7949H2.83496V2.12988Z'
        stroke={color}
        strokeWidth='4'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Courier
